module.exports = __webpack_public_path__ + "static/media/1.c975a1a7.jpg";